export default defineNuxtRouteMiddleware(async (to) => {
  if (
    to.path === "/" ||
    to.path === "/revamp" ||
    to.path.includes("/login") ||
    to.path.includes("/maintenance")
  ) {
    return;
  }

  await usePublicInfoStore().getToggleFeature();

  if (useToggleCheck("GENERAL", true)) {
    useAuthStore().clearTokens();

    const isFromRevampPath = /revamp/.test(to.path);
    return navigateTo({ path: `${isFromRevampPath ? "/revamp" : ""}/login` });
  }
});
